const searchConsole = (site) => site.searchConsole;

/**
 * Every signal stored for a page per day, in the order of the chart's tabs: Google Analytics holds
 * organic sessions only, Search Console holds impressions, position and clicks.
 * `tab` is the tab's label where `label` is too long for it. `available` says whether the workspace has
 * linked the signal's source. `period`, `format`, `lowerIsBetter` and `unit` are how `PeriodCompareChart` reads a period of it and shows it.
 */
export const SERIES = [
    { key: "sessions", label: "Organic sessions", tab: "Sessions", color: "#6366f1", available: (site) => site.source === "sessions" },
    { key: "impressions", label: "Impressions", color: "#14b8a6", available: searchConsole },
    { key: "position", label: "Position", color: "#f97316", available: searchConsole, period: "mean", format: "decimal", lowerIsBetter: true },
    { key: "clicks", label: "Clicks", color: "#0ea5e9", available: searchConsole },
];
